import axios from "axios";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";

// function getSubdomain() {
//   const hostname = window.location.hostname;
//   const parts = hostname.split(".");
//   if (parts.length >= 2) {
//     return parts[0];
//   }
//   return null;
// }

// const API_HOST = process.env.REACT_APP_BASE_URL;
// const subdomain = getSubdomain();
// let AtriumApi = axios.create({
//   baseURL: API_HOST + "/api",
//   headers: {
//     "Content-Type": "application/json",
//     ...(subdomain && { "x-church-slug": subdomain }),
//   },
//   retries: 0,
// });

export function getSubdomain() {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  if (parts.length >= 2) {
    return parts[0];
  }
  return null;
}

const subdomain = getSubdomain();

const API_HOST = process.env.REACT_APP_BASE_URL;

const AtriumApi = axios.create({
  baseURL: API_HOST + "/api",
  headers: {
    "Content-Type": "application/json",
    ...(subdomain && { "x-church-slug": subdomain }),
  },
});

AtriumApi.interceptors.request.use(
  (config) => {
    try {
      const subdomain = getSubdomain();
      if (subdomain) {
        config.headers["x-church-slug"] = subdomain;
      }
      const token = localStorage.auth && JSON.parse(localStorage.auth);
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    } catch (error) {
      return config;
    }
  },
  (error) => Promise.reject(error)
);
// AtriumApi.interceptors.request.use(
//   function (config) {
//     let token;
//     try {
//       const dynamicSubdomain = getSubdomain();
//       if (dynamicSubdomain) {
//         config.headers["x-church-slug"] = dynamicSubdomain;
//       }
//       token = localStorage.auth && JSON.parse(localStorage.auth);
//       if (token) config.headers["Authorization"] = `Bearer ${token}`;
//     } finally {
//       return config;
//     }
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

AtriumApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.code === "ERR_BAD_REQUEST") {
      if (error.status === 401) {
        localStorage.clear();
        window.location.href = "/auth/signin"; // Redirect to login page
        toast.error("Session expired. Please sign in again.");
        if (
          error.response &&
          error.response.data?.error === "Token is expired"
        ) {
          if (error.config.retries < 3) {
            const response = await axios
              .post(
                "/api/v1/refresh-token",
                {},
                { baseURL: API_HOST, withCredentials: false }
              )
              .catch();
            if (!response) {
              // maybe refresh token is flushed, so we can't refresh token anymore
              throw error;
            }

            const user = jwtDecode(response.data.token);
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("auth", JSON.stringify(response.data.token));
            const config = error.config;
            config.headers["Authorization"] = `Bearer ${response.data.token}`;
            config.retries += 1;
            return await AtriumApi(config);
          }

          throw error;
        }
        return error.response;
      } else if (error.status === 422) {
        return error.response;
      }
    }
    throw error;
  }
);

export default AtriumApi;
